import api from '@/api/axios';
import type { ModulesInUseResponse } from '@/types';

export const fetchModulesInUse = async (supplierId: string): Promise<ModulesInUseResponse> => {
  const { data } = await api.get<ModulesInUseResponse>(`/suppliers/${supplierId}/modules-in-use`);

  return data;
};
